import { ActiveAppletDispatchCommand } from '@signageos/actions/dist/Applet/activeAppletActions';
import { SystemLog } from '@signageos/actions/dist/SystemLog/systemLogActions';
import { ActionsLimit } from '@signageos/common-types/dist/Device/Actions/ActionLimit';

export const defaultActionLimits: ActionsLimit = {
	[ActiveAppletDispatchCommand]: {
		limit: 30,
		windowSecs: 60,
	},
	[SystemLog]: {
		limit: 30,
		windowSecs: 60,
	},
};
